module.exports = __webpack_public_path__ + "static/media/Panel.1b0e2c28.png";